import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import KerbouzierHome from '../kerbouzier/Home';

function Router() {
  return (
    <Routes>
      <Route exact path="/kerbouzier/home" element={<KerbouzierHome />} />
    </Routes>
  );
}

export default Router;
